import React, { useEffect } from "react";

const MessageA15I = (props) => {
  useEffect(() => {
    // Store code for send button to use
    if (props?.item?.code) {
      localStorage.setItem("a15iCode", props.item.code);
    }

    // Enable the "Type your query..." input box
    props?.handleInputBox?.(true);

    // Focus the input box
    const tx = document.getElementById("tx");
    if (tx) {
      tx.focus();
      tx.placeholder = props?.item?.text || "Type your query...";
    }

    return () => {
      localStorage.removeItem("a15iCode");
    };
  }, []);

  return null;
};

export default MessageA15I;
